import useUserLocation from '@alltrails/context/hooks/useUserLocation';
import { isTripPlannerSearchAreaFarAway, type TripPlannerSearchArea } from '../utils/tripPlannerSearchArea';
import useIsTripPlannerAvailable from './useIsTripPlannerAvailable';

const useIsTripPlannerAvailableForArea = ({ mapBounds, mapCenter }: TripPlannerSearchArea = {}) => {
  const isTripPlannerAvailable = useIsTripPlannerAvailable();
  const userLocation = useUserLocation();
  return isTripPlannerAvailable && isTripPlannerSearchAreaFarAway({ mapBounds, mapCenter, userLocation });
};

export default useIsTripPlannerAvailableForArea;
